import { connect } from "react-redux";

import Component from "./Component";
import { updateGameData as updateGameDataForList } from "domain/GamesSearch/actions";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";
import { updateGameData as updateRegularGameData } from "domain/RegularGames/actions";

const mapDispatchToProps = (dispatch, ownProps) => {
    const { isRegular } = ownProps;

    const updateGameData = (id, gameData) => {
        if (!isRegular) {
            dispatch(updateGameDataForList(id, gameData));
            dispatch(updateGameDataForPage(id, gameData));
            return;
        }
        dispatch(updateRegularGameData(id, gameData));
    };

    return {
        updateGameData,
    };
};

export default connect(null, mapDispatchToProps)(Component);
